module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_desktop_03@2x-65ee7653265b3ac1acf334283e82d173.jpg";